import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import type { FC } from 'react';
import { useState } from 'react';
import { EDR_COLORS } from './edrTokens';

export type EdrOverflowMenuItem = {
  label: string;
  onClick?: () => void;
  tone?: 'default' | 'danger' | 'success';
};

type EdrOverflowMenuProps = {
  items: EdrOverflowMenuItem[];
  onView?: () => void;
};

export const EdrOverflowMenu: FC<EdrOverflowMenuProps> = ({ items, onView }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreHorizIcon style={{ fontSize: 18, color: EDR_COLORS.textMuted }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {items.map((item, index) => (
          <MenuItem
            key={item.label}
            onClick={(event) => {
              event.stopPropagation();
              handleClose();
              if (index === 0 && onView) onView();
              item.onClick?.();
            }}
            style={{
              fontSize: 13,
              color:
                item.tone === 'danger'
                  ? EDR_COLORS.critical
                  : item.tone === 'success'
                    ? EDR_COLORS.success
                    : EDR_COLORS.textBody,
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
